import { gql } from '@apollo/client';
import {
    CompleteRiskFragment,
    CriticalToQualityFactorWidgetFragment,
    CriticalVariableAssociatedRiskFragment,
    CriticalVariableFragment,
    LibraryRiskFragment,
    RiskFragment,
    AssignLibraryFunctionalDataReviewFragment,
    FunctionalDataReviewsIncludingCtQfDetailFragment,
    FunctionalDataReviewsByStudyAndCtqFragment,
    RiskObservationFragment,
    RiskActionFragment,
    CriticalVariablesForRiskFragment,
    RiskEvaluationModelFragment,
    RiskEvaluationFragment,
    CriticalVariableListItemFragment, StudyControlFragment, RisksAndObservationsVendorIdsFragment,
    RisksQualityIssueIdsFragment,
    RiskDashboardConfigFragment,
    RiskAssessmentTagListItemFragment,
    RisksAssignedControlIdsFragment,
    RiskAssessmentCmControlChartsFragment,
    RiskCommentPocFragment, ControlsHubChartConfigFragment,
    RisksAndControlsLovUsageFragment,
    StudyControlsLovUsageFragment, CommentWithDeletedRepliesFragment,
    RiskIqCommentCountsFragment,
} from '@queries/fragments';

export const GET_CRITICAL_VARIABLES = gql`
    query getCriticalVariables($studyId: ObjectId!) {
        risks(studyId: $studyId) {
            ...CompleteRiskFields
        },
        criticalVariables(studyId: $studyId) {
            ...CriticalVariableFields
        }
    }
    ${CompleteRiskFragment}
    ${CriticalVariableFragment}
`;


export const GET_CRITICAL_VARIABLES_INCLUDING_DELETED_AND_INFLIGHT = gql`
    query getCriticalVariablesIncludingDeletedAndInflight($studyId: ObjectId!) {
        criticalVariablesIncludingDeletedAndInflight(studyId: $studyId) {
            id
            description
        }
    }
`;


export const GET_ORGANISATION_CRITICAL_VARIABLES = gql`
    query getOrganisationCriticalVariables {
        organisationCriticalVariables {
            ...CriticalVariableFields
        }
    }
    ${CriticalVariableFragment}
`;


export const GET_CRITICAL_VARIABLE_ASSOCIATED_RISKS = gql`
    query getCriticalVariableAssociatedRisks($studyId: ObjectId!, $criticalVariableId: ObjectId!) {
        associatedRisks(studyId: $studyId, criticalVariableId: $criticalVariableId) {
            ...CriticalVariableAssociatedRiskFields
        }
    }
    ${CriticalVariableAssociatedRiskFragment}
`;

export const BULK_UPDATE_CRITICAL_VARIABLES = gql`
    mutation bulkUpdateCriticalVariables($active: Boolean, $critical: Boolean, $criticalVariableIds: [ObjectId],
        $datasource: String, $edcEntry: NullableObjectIdType, $responsibleVendors: [ObjectId], $studyId: ObjectId, $system: String, 
        $type: NullableObjectIdType, $justification: String) {
        bulkUpdateCriticalVariables(active: $active,critical: $critical, criticalVariableIds: $criticalVariableIds
            , datasource: $datasource, edcEntry: $edcEntry, responsibleVendors: $responsibleVendors, studyId: $studyId, system: $system, 
            type: $type, justification: $justification )
    }
`;


export const ADD_CRITICAL_TO_QUALITY_FACTOR = gql`
    mutation createCriticalVariable($criticalVariable: CriticalVariableInput!) {
        createCriticalVariable(criticalVariable: $criticalVariable) {
            ...CriticalVariableFields
        }
    }
    ${CriticalVariableFragment}
`;

export const UPDATE_CRITICAL_TO_QUALITY_FACTOR = gql`
    mutation updateCriticalVariable($criticalVariable: CriticalVariableInput!) {
        updateCriticalVariable(criticalVariable: $criticalVariable) {
            ...CriticalVariableFields
        }
    }
    ${CriticalVariableFragment}
`;

export const DELETE_CRITICAL_VARIABLE = gql`
    mutation deleteCriticalVariable($id: ObjectId!, $reason: String!) {
        deleteCriticalVariable(id: $id, reason: $reason)
    }
`;

export const UPDATE_CRITICALVARIABLE_RIQ_STATUS = gql`
    mutation updateCriticalVariableRiqStatus(
        $riqId: String!
        $status: RiqStatusType!
        $studyId: ObjectId!
        $reason: String
        $code: String
    ) {
        updateCriticalVariableRiqStatus(
            riqId: $riqId
            status: $status
            studyId: $studyId
            reason: $reason
            code: $code
        ) {
            ...CriticalVariableFields
        }
    }
    ${CriticalVariableFragment}
`;

export const UPDATE_CRITICALVARIABLE_RIQ_DETAILS = gql`
    mutation updateCriticalVariableRiqDetails(
        $description: String
        $riqId: String!
        $studyId: ObjectId!
        $typeId: ObjectId
    ) {
        updateCriticalVariableRiqDetails(description: $description, riqId: $riqId, studyId: $studyId, typeId: $typeId) {
            ...CriticalVariableFields
        }
    }
    ${CriticalVariableFragment}
`;

export const UPDATE_RISK_RIQ_DETAILS = gql`
    mutation updateRiskRiqDetails($categoryId: ObjectId, $riqId: String!, $statement: String, $studyId: ObjectId!) {
        updateRiskRiqDetails(categoryId: $categoryId, riqId: $riqId, statement: $statement, studyId: $studyId) {
            ...RiskFields2
        }
    }
    ${RiskFragment}
`;

export const UPDATE_RISK_RIQ_STATUS = gql`
    mutation updateRiskRiqStatus(
        $riqId: String!
        $status: RiqStatusType!
        $studyId: ObjectId!
        $reason: String
        $code: String
    ) {
        updateRiskRiqStatus(riqId: $riqId, status: $status, studyId: $studyId, reason: $reason, code: $code) {
            ...RiskFields2
        }
    }
    ${RiskFragment}
`;

export const GET_LIBRARY_RISKS = gql`
    query getLibraryRisksNew($organisationId: ObjectId, $includeSystemRisks: Boolean) {
        libraryRisks(organisationId: $organisationId, includeSystemRisks: $includeSystemRisks) {
            ...LibraryRiskFields
        }
    }
    ${LibraryRiskFragment}
`;

export const ADD_RISK = gql`
    mutation createRisk($risk: RiskInput!) {
        createRisk(risk: $risk) {
            ...RiskFields2
        }
    }
    ${RiskFragment}
`;

export const ADD_RISK_AND_ASSIGN_CRITICAL_TO_QUALITY_FACTOR = gql`
    mutation createRiskAndAssignCriticalToQualityFactor($risk: RiskInput!, $criticalToQualityFactorId: ObjectId!) {
        createRiskAndAssignCriticalToQualityFactor(risk: $risk, criticalToQualityFactorId: $criticalToQualityFactorId) {
            ...RiskFields2
        }
    }
    ${RiskFragment}
`;

export const ASSIGN_RISKS = gql`
    mutation assignRisks($id: ObjectId!, $riskIds: [ObjectId!]!) {
        assignRisks(id: $id, riskIds: $riskIds) {
            ...CriticalVariableFields
        }
    }
    ${CriticalVariableFragment}
`;

export const ASSIGN_CTQS = gql`
    mutation assignCtQs($id: ObjectId!, $criticalVariableIds: [ObjectId!]!) {
        assignCriticalVariables(id: $id, criticalVariableIds: $criticalVariableIds) {
            ...RiskFields2
        }
    }
    ${RiskFragment}
`;

export const UPSERT_RISK = gql`
    mutation upsertRisk($risk: RiskInput!) {
        upsertRisk(risk: $risk) {
            ...RiskFields2
        }
    }
    ${RiskFragment}
`;

export const SAVE_RISK_REVIEW_COMPLETE = gql`
    mutation saveRiskReviewComplete($dateLastReviewed: Date!, $id: ObjectId!, $studyId: ObjectId!) {
        saveRiskReviewComplete(id: $id, studyId: $studyId, dateLastReviewed: $dateLastReviewed) {
            ...RiskFields2
        }
    }
    ${RiskFragment}
`;

export const UPSERT_RISKS = gql`
    mutation upsertRisks($risks: [RiskInput!]!) {
        upsertRisks(risks: $risks) {
            ...RiskFields2
        }
    }
    ${RiskFragment}
`;

export const DELETE_RISK = gql`
    mutation deleteRisk($id: ObjectId!, $reason: String) {
        deleteRisk(id: $id, reason: $reason)
    }
`;

export const ASSIGN_STUDY_AND_LIBRARY_RISKS = gql`
    mutation assignStudyAndLibraryRisks($id: ObjectId!, $studyRiskIds: [ObjectId!]!, , $libraryRisks: [RiskInput!]!) {
        assignStudyAndLibraryRisks(id: $id, studyRiskIds: $studyRiskIds, libraryRisks: $libraryRisks) {
            ...CriticalVariableFields
        }
    }
    ${CriticalVariableFragment}
`;

export const ASSIGN_LIBRARY_FUNCTIONAL_DATA_REVIEWS = gql`
    mutation assignLibraryFunctionalDataReview($id: ObjectId!, $libraryFdrs: [FunctionalDataReviewInput!]!) {
        assignLibraryFunctionalDataReview(id: $id, libraryFdrs: $libraryFdrs) {
            ...CriticalVariableFields
        }
    }
    ${CriticalVariableFragment}
`;

export const GET_LIBRARY_FUNCTIONAL_DATA_REVIEWS_FOR_ASSIGNMENT = gql`
    query getlibraryFunctionalDataReviewsForAssignment {
        libraryFunctionalDataReviews {
            ...AssignLibraryFunctionalDataReviewFields
        }
    }
    ${AssignLibraryFunctionalDataReviewFragment}
`;

export const CTQ_WIDGET_VALUES = gql`
    query CtqWidgetValues($studyId: ObjectId!) {
        criticalToQualityFactorWidgetValues(studyId: $studyId) {
            ...CriticalToQualityFactorWidgetFields
        }
    }
    ${CriticalToQualityFactorWidgetFragment}
`;

export const GET_FUNCTIONAL_DATA_REVIEWS_WITH_CTQF_DETAIL = gql`
    query getFunctionalDataReviewsWithCtQfDetail($studyId: ObjectId!) {
        functionalDataReviewsIncludingCtQfDetail(studyId: $studyId) {
            ...FunctionalDataReviewsIncludingCtQfDetailFields
        }
    }
    ${FunctionalDataReviewsIncludingCtQfDetailFragment}
`;

export const GET_FUNCTIONAL_DATA_REVIEWS_BY_STUDY_AND_CTQ = gql`
    query getFunctionalDataReviewsByStudyAndCtq($studyId: ObjectId!, $ctqId: ObjectId!) {
        functionalDataReviewsByStudyAndCtq(studyId: $studyId, ctqId: $ctqId) {
            ...FunctionalDataReviewsByStudyAndCtqFields
        }
    }
    ${FunctionalDataReviewsByStudyAndCtqFragment}
`;

export const GET_COMPLETE_RISKS_RISK_LOG = gql`
    query getCompleteRisksRiskLog($studyId: ObjectId!) {
        risks(studyId: $studyId) {
            ...CompleteRiskFields
        }
    }
    ${CompleteRiskFragment}
`;

export const GET_RISKS_INCLUDING_DELETED_AND_INFLIGHT = gql`
    query getRisksIncludingDeletedAndInflight($studyId: ObjectId!) {
        risksIncludingDeletedAndInflight(studyId: $studyId) {
            id
            statement
        }
    }
`;

export const GET_NAMED_ITEMS_ID_NAME_BY_TYPE_FOR_STUDY = gql`
    query getNamedItemsIdNameByTypeForStudy($studyId: ObjectId!, $type: NamedItemType!, $includeSystemItems: Boolean) {
        namedItemsByTypeForStudy(studyId: $studyId, type: $type, includeSystemItems: $includeSystemItems) {
            id
            name
        }
    }
`;

export const GET_RISKS_ASSIGNED_CONTROL_IDS = gql`
    query getRisksAssignedControlIds($studyId: ObjectId!) {
        risks(studyId: $studyId) {
            ...RisksAssignedControlIdsFields
        }
    }
    ${RisksAssignedControlIdsFragment}
`;

export const UPDATE_FUNCTIONAL_DATA_REVIEW =  gql`
 mutation updateFunctionalDataReviewComment($id: ObjectId!, $comment: String!) {
     updateFunctionalDataReviewComment(id: $id, comment: $comment)
 }
`;


export const DELETE_FUNCTIONAL_DATA_REVIEW =  gql`
 mutation deleteFunctionalDataReview($id: ObjectId!, $reason: String!) {
     deleteFunctionalDataReview(id: $id, reason: $reason)
 }
`;

export const GET_RISK_OBSERVATIONS_AND_ACTIONS = gql`
    query studyRiskObservations($studyId: ObjectId!, $riskId: ObjectId) {
        riskObservations(studyId: $studyId, riskId: $riskId) {
            ...RiskObservationFields
        }
    }
    ${RiskObservationFragment}
`;

export const GET_RISK_OBSERVATIONS_AND_ACTIONS_AND_RISKS = gql`
    query studyRiskObservationsAndRisks($studyId: ObjectId!, $riskId: ObjectId) {
        riskObservations(studyId: $studyId, riskId: $riskId) {
            ...RiskObservationFields
        }
        risks(studyId: $studyId) {
            ...CompleteRiskFields
        },
    }
    ${CompleteRiskFragment}
    ${RiskObservationFragment}
`;

export const SAVE_RISK_OBSERVATION = gql`
    mutation saveRiskObservation($observation: RiskObservationInput!) {
        saveRiskObservation(observation: $observation) {
            ...RiskObservationFields
        }
    }
    ${RiskObservationFragment}
`;

export const SAVE_RISK_ACTION = gql`
    mutation saveRiskAction($action: RiskActionInput!, $observationId: ObjectId!, $riskId: ObjectId!) {
        saveRiskAction(action: $action, observationId: $observationId, riskId: $riskId) {
            ...RiskActionFields
        }
    }
    ${RiskActionFragment}
`;

export const DELETE_RISK_OBSERVATION = gql`
    mutation deleteRiskObservationNew($id: ObjectId!, $reason: String) {
        deleteRiskObservation(id: $id, reason: $reason)
    }
`;

export const RESTORE_RISK_OBSERVATION = gql`
    mutation unDeleteRiskObservationNew($id: ObjectId!, $reason: String, $unDeleteActions: Boolean = false) {
        unDeleteRiskObservation(id: $id, reason: $reason, unDeleteActions: $unDeleteActions)
    }
`;

export const DELETE_RISK_OBSERVATION_ACTION = gql`
    mutation deleteRiskObservationActionNew($actionId: ObjectId!, $observationId: ObjectId!, $reason: String) {
        deleteRiskObservationAction(actionId: $actionId, observationId: $observationId, reason: $reason)
    }
`;

export const RESTORE_RISK_OBSERVATION_ACTION = gql`
    mutation unDeleteRiskObservationActionNew($actionId: ObjectId!, $observationId: ObjectId!, $reason: String) {
        unDeleteRiskObservationAction(actionId: $actionId, observationId: $observationId, reason: $reason)
    }
`;

export const GET_CRITICAL_VARIABLES_FOR_RISK = gql`
    query getCriticalVariablesForRisk($studyId: ObjectId!, $riskId: ObjectId!) {
        criticalVariablesForRisk(studyId: $studyId, riskId: $riskId) {
            ...CriticalVariablesForRiskFields
        }
    }
    ${CriticalVariablesForRiskFragment}
`;

export const GET_RISK_EVALUATION_MODELS = gql`
    query getRiskEvaluationModelsNew {
        riskEvaluationModels {
            ...RiskEvaluationModelFields
        }
    }
    ${RiskEvaluationModelFragment}
`;

export const SAVE_RISK_EVALUATION = gql`
    mutation saveRiskEvaluation($riskId: ObjectId!, $evaluation: RiskEvaluationInput!) {
        saveRiskEvaluation(evaluation: $evaluation, riskId: $riskId ) {
            ...RiskEvaluationFields
        }
    }
    ${RiskEvaluationFragment}
`;

export const ASSIGN_CRITICAL_VARIABLES = gql`
    mutation assignCriticalVariablesToRisk($id: ObjectId!, $criticalVariableIds: [ObjectId!]!) {
        assignCriticalVariables(id: $id, criticalVariableIds: $criticalVariableIds) {
            id
        }
    }
`;

export const ADD_CRITICAL_TO_QUALITY_FACTOR_AND_ASSIGN_RISK = gql`
    mutation createCriticalVariableAndAssignRisk(
        $criticalVariable: CriticalVariableInput!,
        $riskId: ObjectId!
    ) {
        createCriticalVariableAndAssignRisk(
            criticalVariable: $criticalVariable,
            riskId: $riskId
        ) {
            ...CriticalVariableFields
        }
    }
    ${CriticalVariableFragment}
`;

export const GET_UNASSIGNED_CRITICAL_VARIABLES_FOR_RISK = gql`
    query getUnassignedCriticalVariablesForRisk($studyId: ObjectId!, $riskId: ObjectId!) {
        unassignedCriticalVariablesForRisk(studyId: $studyId, riskId: $riskId) {
            ...CriticalVariableListItemFields
        }
    }
    ${CriticalVariableListItemFragment}
`;

export const CREATE_CONTROL_AND_ASSIGN_TO_RISK = gql`
    mutation createControlAndAssignToRisk(
        $control: StudyControlInput!, 
        $riskId: ObjectId!
    ) {
        createControlAndAssignToRisk(
            control: $control, 
            riskId: $riskId
        ) {
            ...StudyControlFields
        }
    }
    ${StudyControlFragment}
`;

export const ASSIGN_CONTROLS = gql`
    mutation assignControls($id: ObjectId!, $controlIds: [ObjectId!]!) {
        assignControls(id: $id, controlIds: $controlIds) {
            ...RiskFields2
        }
    }
    ${RiskFragment}
`;

export const UPDATE_CONTROL=  gql`
    mutation updateControl($control: StudyControlInput!) {
        updateControl(control: $control) {
            ...StudyControlFields
        }
    }
    ${StudyControlFragment}
`;

export const ASSIGN_STUDY_AND_LIBRARY_CONTROLS = gql`
    mutation assignStudyAndLibraryControls(
        $id: ObjectId!,
        $studyControlIds: [ObjectId!]!,
        $libraryControlIds: [ObjectId!]!)
    {
        assignStudyAndLibraryControls(
            id: $id,
            studyControlIds: $studyControlIds,
            libraryControlIds: $libraryControlIds)
        {
            ...RiskFields2
        }
    }
    ${RiskFragment}
`;

export const BULK_UPDATE_RISKS = gql`
    mutation bulkUpdateRisks($categoryId: NullableObjectIdType, $controlStrategyId: NullableObjectIdType,
        $countries: [CountryInputType], $dateIdentified: Date, $dateLastReviewed: Date, $closedDate: Date,
        $internalOnly: Boolean, $ownerId: NullableObjectIdType, $qualityIssueId: NullableObjectIdType,
        $qualityIssueReference: String $responsibleFunctionId: NullableObjectIdType,
        $reviewFrequencyPeriod: ConvertableInt, $reviewFrequencyUnits: TimeFrequencyType,
        $reviewRequired: Boolean, $riskIds: [ObjectId], $status: RiskStatusType, $studyId: ObjectId,
        $vendorIds: [NullableObjectIdType]) {
        bulkUpdateRisks(categoryId: $categoryId, controlStrategyId: $controlStrategyId, countries: $countries,
            dateIdentified: $dateIdentified, dateLastReviewed: $dateLastReviewed, closedDate: $closedDate, internalOnly: $internalOnly,
            ownerId: $ownerId, qualityIssueId: $qualityIssueId, qualityIssueReference: $qualityIssueReference,
            responsibleFunctionId: $responsibleFunctionId, reviewFrequencyPeriod: $reviewFrequencyPeriod,
            reviewFrequencyUnits: $reviewFrequencyUnits, reviewRequired: $reviewRequired, riskIds: $riskIds,
            status: $status, studyId: $studyId, vendorIds: $vendorIds )
    }
`;

export const BULK_UPDATE_CONTROLS = gql`
    mutation bulkUpdateControls(
        $actionToBeTaken: String
        $activeDate: Date
        $additionalInformation: String
        $controlIds: [ObjectId!]!
        $controlPhaseId: NullableObjectIdType
        $dateIdentified: Date
        $inactiveDate: Date
        $ownerId: NullableObjectIdType
        $purpose: String
        $responsibleFunctionId: NullableObjectIdType
        $reviewFrequencyPeriod: ConvertableInt
        $reviewFrequencyUnits: TimeFrequencyType
        $studyId: ObjectId
        $threshold: String
        $typeId: NullableObjectIdType
        $volume: String
    ) {
        bulkUpdateControls(
            actionToBeTaken: $actionToBeTaken
            activeDate: $activeDate
            additionalInformation: $additionalInformation
            controlIds: $controlIds
            controlPhaseId: $controlPhaseId
            dateIdentified: $dateIdentified
            inactiveDate: $inactiveDate
            ownerId: $ownerId
            purpose: $purpose
            responsibleFunctionId: $responsibleFunctionId
            reviewFrequencyPeriod: $reviewFrequencyPeriod
            reviewFrequencyUnits: $reviewFrequencyUnits
            studyId: $studyId
            threshold: $threshold
            typeId: $typeId
            volume: $volume
        )
    }
`;

export const RISKS_AND_OBSERVATIONS_VENDOR_IDS = gql`
    query risksAndObservationsVendorIds {
        organisationRisks {
            ...RisksAndObservationsVendorIdsFields
        }
    }
    ${RisksAndObservationsVendorIdsFragment}
`;

export const RISKS_QUALITY_ISSUE_IDS = gql`
    query risksQualityIssueIds {
        organisationRisks {
            ...RisksQualityIssueIdsFields
        }
    }
    ${RisksQualityIssueIdsFragment}
`;

export const ORGANISATION_RISKS_LOV_USAGE = gql`
    query organisationRisksLovUsage {
        organisationRisks {
            ...RisksAndControlsLovUsageFields
        }
    }
    ${RisksAndControlsLovUsageFragment}
`;

export const ORGANISATION_CONTROLS_LOV_USAGE = gql`
    query organisationControlsLovUsage {
        organisationControls {
            ...StudyControlsLovUsageFields
        }
    }
    ${StudyControlsLovUsageFragment}
`;

export const RISK_DASHBOARD_CONFIG = gql`
    query riskDashboardConfig {
        riskDashboardConfig {
            ...RiskDashboardConfigFields
        }
    } 
    ${RiskDashboardConfigFragment}
`;

export const RISK_DASHBOARD_ALL_PANELS = gql`
    query defaultRiskDashboardConfig {
        defaultRiskDashboardConfig {
            ...RiskDashboardConfigFields
        }
    } 
    ${RiskDashboardConfigFragment}
`;

export const UPSERT_RISK_DASHBOARD_CONFIG = gql`
    
    mutation upsertRiskDashboardConfig($RiskDashboardConfig : RiskDashboardConfigInput!) {
        upsertRiskDashboardConfig(riskDashboardConfig: $RiskDashboardConfig) {
            ...RiskDashboardConfigFields
        }
    }
    ${RiskDashboardConfigFragment}
`;

export const RISK_ASSESSMENT_TAGS = gql`
    query getRiskAssessmentTags($studyId: ObjectId!) {
        riskAssessmentTags(studyId: $studyId) {
            ...RiskAssessmentTagListItemFields
        }
    }
    ${RiskAssessmentTagListItemFragment}
`;

export const UPSERT_RISK_ASSESSMENT_TAG = gql`
    mutation upsertRiskAssessmentTag($riskAssessmentTag: RiskAssessmentTagInput!) {
        upsertRiskAssessmentTag(riskAssessmentTag: $riskAssessmentTag) {
            ...RiskAssessmentTagListItemFields
        }
    }
    ${RiskAssessmentTagListItemFragment}
`;

export const ASSIGN_CM_CONTROLS = gql`
    mutation assignCmControlChartsToRisk($id: ObjectId!, $cmControlChartsIds: [ObjectId!]!) {
        assignCmControlCharts(id: $id, cmControlChartsIds: $cmControlChartsIds) {
            id
        }
    }
`;

export const GET_CM_CONTROLS_CHARTS = gql`
    query getControlChartsForRisk($studyId: ObjectId!) {
        getControlChartsForRisk(studyId: $studyId) {
            ...RiskAssessmentCmControlChartItemFields
        }
    }
    ${RiskAssessmentCmControlChartsFragment}
`;

export const RISK_POC_COMMENT = gql`
    mutation addRiskPocComment($riskComment: RiskPocCommentInput!) {
        addRiskPocComment(riskComment: $riskComment) {
            ...RiskCommentPocFields
        }
    }
    ${RiskCommentPocFragment}
`;
export const GET_CM_CONTROL_CHART_RISKS = gql`
    query getCmControlsChartAssociatedRisks($studyId: ObjectId!, $riskIds: [ObjectId!]!) {
        getCmControlsChartAssociatedRisks(studyId: $studyId, riskIds: $riskIds) {
            ...CompleteRiskFields
        }
    }
    ${CompleteRiskFragment}
`;

export const GET_CM_CONTROL_RISKS_INFO = gql`
    query getCmControlRisksInfo($studyId: ObjectId!, $riskIds: [ObjectId!]!) {
        getCmControlsAssociatedRisksInfo(studyId: $studyId, riskIds: $riskIds ) {
            id
            internalOnly
        }
    }
`;

export const GET_CM_CONTROLS_HUB_CHART_CONFIG = gql`
    query controlsHubChartConfig($studyId: ObjectId!) {
        controlsHubChartConfig(studyId: $studyId) {
            ...ControlsHubChartConfigFields
        }
    }
    ${ControlsHubChartConfigFragment}
`;

export const UPSERT_CM_CONTROLS_HUB_CHART_CONFIG = gql`
    mutation updateControlsHubChartConfig($studyId: ObjectId!, $cutoffDate: DateTime) {
        updateControlsHubChartConfig(studyId: $studyId, cutoffDate: $cutoffDate) {
            ...ControlsHubChartConfigFields
        }
    }
    ${ControlsHubChartConfigFragment}
`;

export const ASSIGN_CM_CONTROL_RISKS = gql`
    mutation assignRisksToCmControlChart($id: ObjectId!, $riskIds: [ObjectId!]!) {
        assignRisksToCmControlChart(id: $id, riskIds: $riskIds) {
            id
        }
    }
`;

export const GET_RISK_IQ_PROTOCOL_COMMENT_COUNTS = gql`
    query getRiskIqProtocolCommentCounts($commentsInput: RiskIqCommentCountsInput!) {
        riskIqProtocolCommentCounts(comments: $commentsInput) {
            ...RiskIqCommentCountsFields
        }
    }
    ${RiskIqCommentCountsFragment}
`;

export const GET_RISK_IQ_PROTOCOL_COMMENT_COUNTS_BY_ID = gql`
    query getRiskIqProtocolCommentCountsById($commentsInput: RiskIqCommentCountsByIdInput!) {
        riskIqProtocolCommentCountsById(comments: $commentsInput) {
            ...RiskIqCommentCountsFields
        }
    }
    ${RiskIqCommentCountsFragment}
`;
